// extracted by mini-css-extract-plugin
module.exports = {"ResetPassword":"ForgotPassword_ResetPassword__3YpWk","FormContainer":"ForgotPassword_FormContainer__89cKX"};